import React from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MViewSummaryAnswerForm from './MViewSummaryAnswerForm';
import { closeModal } from '../../../app/modals/redux/modalActions';
import { submitTugasScores } from './redux/reduxApi';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';

const mapState = (state, ownProps) => {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let loading = state.async.loading;

  return {
    scope,
    loading,
  };
};

const actions = {
  closeModal,
  submitTugasScores,
};

function ModalViewSummaryAnswer({
  scope,
  loading,
  closeModal,
  data,
  submitTugasScores,
}) {
  const id = data?.id;
  const auth = data?.auth;
  const history = useHistory();
  const screenWidth = useScreenWidth();
  const studentDetail = data?.item;
  const answers = data?.item?.answers && JSON.parse(data.item.answers);
  const questions = data?.questions;
  const keyAnswers = data?.keyAnswers;
  const stateScores = data?.stateScores;
  const scores = data?.scores;
  const optScore = data?.optScore;
  let selectedScore =
    scores?.[0] &&
    scores.find((i) => i.studentTugasId + '' === studentDetail.id + '');
  let finalScore;
  let detailScore;
  if (!selectedScore) {
    let selectedStateScore = stateScores.find(
      (i) => i.studentTugasId + '' === studentDetail.id + ''
    );
    finalScore = selectedStateScore?.finalScore;
    detailScore = selectedStateScore?.detailScore;
  } else {
    finalScore = selectedScore?.finalScore;
    detailScore = selectedScore?.detailScore;
  }

  const onFormSubmit = async (values) => {};

  return (
    <Modal
      variant='info'
      label='Summary Jawaban'
      closeModal={closeModal}
      width={screenWidth > 1000 ? 1000 : screenWidth}
    >
      <MViewSummaryAnswerForm
        id={id}
        auth={auth}
        scope={scope}
        loading={loading}
        history={history}
        closeModal={closeModal}
        studentDetail={studentDetail}
        initialValues={{}}
        questions={questions}
        keyAnswers={keyAnswers}
        answers={answers}
        scores={scores}
        optScore={optScore}
        finalScore={finalScore}
        detailScore={detailScore}
        submitTugasScores={submitTugasScores}
        onFormSubmit={onFormSubmit}
      />
    </Modal>
  );
}

export default withRouter(connect(mapState, actions)(ModalViewSummaryAnswer));
